
import { Inertia } from "@inertiajs/inertia";
import { computed, defineComponent } from "vue";
import ButtonGroup from "../Buttons/ButtonGroup.vue";
import Card from "../General/Card.vue";

export default defineComponent({
  setup() {
    const options = [
      {
        id: 1,
        title: "Timesalg",
        url: route("reports.orders.hours"),
      },
      {
        id: 2,
        title: "Kategorisalg",
        url: route("reports.orders.categories"),
      },
      {
        id: 3,
        title: "Ukedager",
        url: route("reports.orders.weekdays"),
      }
    ];

    const selected = computed(() => {
      const result = options.filter((item) => item.url === route(route().current() ?? ""));

      if (result.length > 0) {
        return result[0].id;
      }

      return null;
    });

    const navigate = (item: any) => {
      Inertia.get(item.url);
    }

    return {
      options,
      selected,
      navigate,
    };
  },
  components: { ButtonGroup, Card }
});
